import React, { useEffect } from 'react';

import _ from 'lodash';
import { Div } from 'nexcomponent-ui';
import { useSelector } from 'react-redux';

import {
  productKeyAccountBreadCrumb,
} from '../../../../Enum/Breadcrumb/ProductKeyAccountBreadcrumb';
import { MAPPING_CODE } from '../../../../Enum/MappingCode/MappingCode';
import {
  ROUTER_CONSTANT,
} from '../../../../Enum/RouterConstant/RouterConstant';
import {
  fetchDataApprovalProductKeyAccount,
  fetchProductKeyAccountMappingForm,
} from '../../../../Fetch/FetchData/ProductKeyAccountData';
import { mappingFormPageStateGroup } from '../../../../Store/StateGroup';
import CancelOverwrite
  from '../../../Organisms/Button/CancelOverwrite/CancelOverwrite';
import MappingForm
  from '../../../Organisms/Form/MappingForm/MappingForm/MappingForm';
import HeaderPageMapping
  from '../../../Organisms/Header/HeaderPageMapping/HeaderPageMapping';
import ModalMapping from '../../../Organisms/Modal/ModalMapping/ModalMapping';

const ProductKeyAccountMappingPage = props => {
  const [, list, , mappingForm] = useSelector(mappingFormPageStateGroup);

  useEffect(() => {
    if (_.has(props.location.state, "data")) {
      const first = _.first(list);
      fetchProductKeyAccountMappingForm(
        props.validToken(),
        props.dispatch,
        "product_key_account_id",
        first.id,
        props.location.state.data.product_key_account_id,
        list,
        props.notify,
        () => props.navigate(ROUTER_CONSTANT.PRODUCT_KEY_ACCOUNT.MAPPING)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list, props.location.state, props.dispatch, props.validToken]);
  return (
    <Div>
      <ModalMapping
        t={props.t}
        dispatch={props.dispatch}
        navigate={props.navigate}
        listNavigate={ROUTER_CONSTANT.PRODUCT_KEY_ACCOUNT.LIST}
        approveFuc={(data, mappingList, mappingCount) =>
          fetchDataApprovalProductKeyAccount(
            props.validToken(),
            data,
            mappingList,
            mappingCount,
            props.notify,
            props.dispatch
          )
        }
        uniqueKey="product_key_account_id"
        nextMapping={(uniqueKey, newId, existId, mappingList) =>
          fetchProductKeyAccountMappingForm(
            props.validToken(),
            props.dispatch,
            uniqueKey,
            newId,
            existId,
            mappingList,
            props.notify,
            () => props.navigate(ROUTER_CONSTANT.PRODUCT_KEY_ACCOUNT.MAPPING)
          )
        }
      />

      <HeaderPageMapping
        title={props.t("PRODUCT_KEY_ACCOUNT:TITLE")}
        listBreadcrumb={productKeyAccountBreadCrumb(props.t)}
        defaultBreadcrumb={props.t("PRODUCT_KEY_ACCOUNT:MAPPING.TITLE")}
        to={ROUTER_CONSTANT.PRODUCT_KEY_ACCOUNT.LIST}
      />
      <MappingForm
        t={props.t}
        validToken={props.validToken}
        dispatch={props.dispatch}
        navigate={props.navigate}
        idKey="product_key_account_id"
        mappingCode={MAPPING_CODE.PRODUCT_KEY_ACCOUNT}
        mappingForm={mappingForm}
      />
      <CancelOverwrite
        t={props.t}
        dispatch={props.dispatch}
        navigate={props.navigate}
        idKey="product_key_account_id"
        mappingForm={mappingForm}
        mappingCode={MAPPING_CODE.PRODUCT_KEY_ACCOUNT}
      />
    </Div>
  );
};

export default ProductKeyAccountMappingPage;
